// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  sectionTitle: {
    marginTop: theme.spacing(1),
    color: '#979797',
    fontSize: theme.spacing(2),
  },
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1.5),
  },
  listContent: {
    display: 'grid',
    gridTemplateColumns: 'auto auto',
    gridRowGap: theme.spacing(2),
    justifyContent: 'space-between',
    alignItems: 'center',
    '&>*:nth-child(2n)': {
      textAlign: 'right',
      fontWeight: 400,
    },
  },
  helperText: {
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(1),
  },
  planButtonGroup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  planButton: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  buttonGroup: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: '-12px',
    marginLeft: '-12px',
  },
  form: {
    marginTop: theme.spacing(1),
  },
  optionDescription: {
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing(4),
    marginTop: theme.spacing(-0.5),
    marginBottom: theme.spacing(1),
  },
  cadenceGroup: {
    marginLeft: theme.spacing(4),
    marginBottom: theme.spacing(1),
  },
  notesField: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  historyList: {
    marginTop: theme.spacing(2),
  },
  historyRow: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'baseline',
    paddingBottom: theme.spacing(0.5),
  },
  historyChange: {
    minWidth: '200px',
  },
  historyNotes: {
    color: theme.palette.text.secondary,
  },
  error: {
    color: theme.palette.error.main,
    marginTop: theme.spacing(1),
  },
});

export default styles;
